import React, { useState, Dispatch, SetStateAction } from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { ActionHandlerFunction, AdminUser } from "@preveil-api";
import { Account, useAppSelector } from "src/common";
import { AddMultipleUsers, AddSingleUserForm } from "..";
import { RootState } from "src/store/configureStore";

type AllProps = {
  current_account: Account;
  org_users: AdminUser[];
  show_modal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  handleAction: ActionHandlerFunction;
}

function AddUsersModalComponent(props: AllProps) {
  const { current_account, org_users, show_modal, handleAction, setShowModal } = props;
  const tab_event_key = { individual: "Add Users", csv_upload: "Importing Users" };
  const org_info = useAppSelector((state: RootState) => state.account.organization);
  const [tab_heading, setTabHeading] = useState<string>(tab_event_key.individual);

  // Description: Handling changing modal tabs and including the correct header.
  function handleTabSelect(event_key: string | null) {
    const tab_heading = event_key === "csv_upload" ? tab_event_key.csv_upload : tab_event_key.individual;
    setTabHeading(tab_heading);
  }

  // Description: Handling the modal close event.
  function handleCancelOnClose() {
    setShowModal(false);
  }

  return <Modal size="lg" show={show_modal} onHide={handleCancelOnClose} centered aria-label={tab_heading}>
    <Modal.Header closeButton>
      <Modal.Title>{tab_heading}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {!!org_info &&
        <Tabs defaultActiveKey="individual" id="invite-new-users" onSelect={handleTabSelect}>
          <Tab eventKey="individual" title="Individual">
            <AddSingleUserForm current_account={current_account} org_info={org_info} setShowModal={setShowModal} users_list={org_users.map(user => user.user_id)} handleAction={handleAction} />
          </Tab>
          <Tab eventKey="csv_upload" title="Group Upload">
            <AddMultipleUsers current_account={current_account} setShowModal={setShowModal} org_info={org_info} org_user_ids={Array.from(org_users.map(user => user.user_id))} handleAction={handleAction}></AddMultipleUsers>
          </Tab>
        </Tabs>
      }
    </Modal.Body>
  </Modal>;
}

export default React.memo(AddUsersModalComponent);
